import { Box, Code, Stack, Table, Text } from '@mantine/core';
import { useMemo } from 'react';
import useUsers from 'src/admin/users/hooks/useUsers';
import PageLoader from 'src/UI/loader/PageLoader';

import { useLlmConfigHistory } from './hooks/useLlmConfig';

export default function LlmConfigHistory() {
  const { history, isLoading } = useLlmConfigHistory();
  const { users } = useUsers();

  const userNameMap = useMemo(() => {
    const map = new Map<string, string>();
    for (const user of users) {
      map.set(user.id, `${user.firstName} ${user.lastName}`);
    }
    return map;
  }, [users]);

  if (isLoading) {
    return <PageLoader />;
  }

  if (!history || history.length === 0) {
    return (
      <Box>
        <Text fw={600} size="md">
          Change History
        </Text>
        <Text size="sm" c="dimmed">
          No changes recorded yet.
        </Text>
      </Box>
    );
  }

  return (
    <Stack gap="sm">
      <Text fw={600} size="md">
        Change History
      </Text>

      <Table striped>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Time</Table.Th>
            <Table.Th>Changed By</Table.Th>
            <Table.Th>Slot</Table.Th>
            <Table.Th>Previous</Table.Th>
            <Table.Th>New</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {history.map((audit, index) => (
            <Table.Tr key={index}>
              <Table.Td>
                <Text size="xs" c="dimmed">
                  {audit.changedAt ? new Date(audit.changedAt).toLocaleString() : '-'}
                </Text>
              </Table.Td>
              <Table.Td>
                <Text size="xs">
                  {audit.changedByUserId
                    ? (userNameMap.get(audit.changedByUserId) ?? audit.changedByUserId)
                    : '-'}
                </Text>
              </Table.Td>
              <Table.Td>
                <Code>{audit.slotKey}</Code>
              </Table.Td>
              <Table.Td>
                {audit.previousModelName ? (
                  <Text size="xs">
                    {audit.previousModelName} ({audit.previousProvider})
                  </Text>
                ) : (
                  <Text size="xs" c="dimmed">
                    -
                  </Text>
                )}
              </Table.Td>
              <Table.Td>
                <Text size="xs">
                  {audit.newModelName} ({audit.newProvider})
                </Text>
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Stack>
  );
}
